module.exports = __webpack_public_path__ + "img/flip-blue.36a2d8a6.svg";